import fetch from 'cross-fetch';

import { companyApi } from '../api';

export const uploadContract = async (companyId, file) => {
  const contract = await companyApi.createContract(companyId, file.name);

  const response = await fetch(contract.upload_url, {
    method: 'PUT',
    body: file
  });

  if (response.status < 200 || response.status > 300 || !response.ok) {
    throw new Error(`Failed uploading the contract. Status: ${response.status}, Message: ${response.statusText}`);
  }

  return contract;
};

export const deleteContract = (companyId, contractId) => companyApi.deleteContract(companyId, contractId);
